import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * React Router の画面遷移ではブラウザのスクロール位置がそのまま残るため、
 * pathname が変わったときだけ新しいページの先頭へ戻す。
 * 記事内の目次（ハッシュリンク）は通常どおり利用できる。
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
